import { planOrder } from "../planHelper";

export function sortArrayByCategory(arr, index) {

    arr.sort((a, b) => {
        let categoryA = a[index];
        let categoryB = b[index];
        let indexA = planOrder.indexOf(categoryA);
        let indexB = planOrder.indexOf(categoryB);

        if (indexA !== -1 && indexB !== -1) {
            // Both categories are in the predefined order
            return indexA - indexB;
        } else {
            // At least one of the categories is not in the predefined order
            return categoryA.localeCompare(categoryB);
        }
    });
    arr.forEach((row, index) => {
        // Set the first element of each row to the current index (starting from 1)
        row[0] = (index + 1).toString() + '.';  // Convert index to string and add a dot (.)
    });

    return arr;
}
